import './Button.css';
import React from 'react';
interface ButtonProps {
    buttonText?: string;
    children?: React.ReactNode;
    icon?: React.ReactNode;
    link?: string;
}

const classname = 'button button_background';
export const Button: React.FC<ButtonProps> = ({ buttonText, link, children, icon }) => {
    return (
        <button className={classname}>
            {buttonText && <span className="button__text">{buttonText}</span>}
            {icon && icon}
        </button>
    );
};
